import { Share2 } from "lucide-react";
import { useState } from "react";

export default function ShareButton({ title, text, url }) {
  const [isCopied, setIsCopied] = useState(false);

  const handleShare = async () => {
    // മൊബൈലിൽ നേരിട്ട് വാട്സാപ്പ് പോലെയുള്ള ആപ്പുകൾ തുറക്കാൻ (Web Share API)
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url,
        });
      } catch (error) {
        console.log("ഷെയർ ചെയ്യാൻ കഴിഞ്ഞില്ല:", error);
      }
    } else {
      // ലാപ്ടോപ്പിലോ മറ്റോ ആണെങ്കിൽ ലിങ്ക് കോപ്പി ചെയ്യാൻ
      try {
        await navigator.clipboard.writeText(url);
        setIsCopied(true);
        // 2 സെക്കന്റിന് ശേഷം കോപ്പി മെസ്സേജ് മാറ്റാൻ
        setTimeout(() => setIsCopied(false), 2000);
      } catch (err) {
        console.error("ലിങ്ക് കോപ്പി ചെയ്യാൻ പറ്റിയില്ല", err);
      }
    }
  };

  return (
    <div className="relative flex items-center">
      <button
        onClick={handleShare}
        className="group relative flex items-center justify-center p-2.5 rounded-full bg-white/80 backdrop-blur-md shadow-sm border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-all duration-300 active:scale-95"
        title="Share this place"
      >
        <Share2 
          className="text-gray-600 group-hover:text-blue-600 transition-colors duration-300" 
          size={20} 
        />
        
        {/* Hover ചെയ്യുമ്പോൾ കാണിക്കുന്ന ചെറിയ ടെക്സ്റ്റ് (Tooltip) */}
        <span className="absolute -bottom-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xs font-medium bg-gray-800 text-white px-2 py-1 rounded shadow-lg whitespace-nowrap">
          Share
        </span>
      </button>

      {/* ലിങ്ക് കോപ്പി ആയാൽ കാണിക്കുന്ന നോട്ടിഫിക്കേഷൻ */}
      {isCopied && (
        <span className="absolute right-12 text-sm font-medium text-green-600 bg-green-50 px-3 py-1 rounded-full border border-green-200 shadow-sm animate-fade-in-out whitespace-nowrap">
          Link Copied! ✓
        </span>
      )}
    </div>
  );
}